<template>
  <div>
    <h4 class="title-report">Response by Days ({{type === 'devices' ? 'Devices' : 'Groups'}})</h4>
    <hr>
    <charts :options="chartOptions"></charts>
  </div>
</template>
<script>
export default {
  props: {
    dates: {
      type: Object,
      default: function () { return { startDate: 'empty', endDate: 'empty' } },
      required: false,
    },
    type: {
      type: String,
      default: 'devices',
      required: false,
    },
    round_id: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      values: null,
      chartOptions: {
        title: {
          text: null,
        },
        subtitle: {
          text: null,
        },
        yAxis: {
          title: {
            text: 'Number of Responses'
          }
        },
        xAxis: {
          categories: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab']
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true
            },
            enableMouseTracking: true
          }
        },
        credits: {
          enabled: false
        },
        series: [],
      }
    };
  },
  watch: {
    dates: {
      handler: function (val, oldVal) {
        this.loadData();
      },
      deep: true
    },
    type: {
      handler: function (val, oldVal) {
        this.loadData();
      },
      deep: true
    }
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData: function () {
      window.axios.get(`dashboards/round/${this.round_id}/responses-by-days/${this.type}/${this.dates.startDate}/${this.dates.endDate}`).then(response => {
        this.chartOptions.series = response.data.data.ByDays;
        this.$emit('endGraphByDays');
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/rounds/dashboard/graphs/ResponsesDevicesByDays.vue